import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import toastr from "toastr"

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useSelector, useDispatch } from "react-redux"
import Loader from "pages/Loader/Loader"

//i18n
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import apiURl from "url"

const clientID = localStorage.getItem("login_id")

const Dashboard = props => {
  const [Counts, setCounts] = useState({
    users: "0",
    clients: "0",
    gardeners: "0",
    companies: "0",
  })

  const [countsReports, setCountReports] = useState("0")

  const navigate = useNavigate()

  // Check session expiration
  const checkSession = () => {
    const expirationTime = localStorage.getItem("expirationTime")
    if (expirationTime && new Date() > new Date(expirationTime)) {
      localStorage.clear()
      toastr.error("Session expired. Please log in again.")
      navigate("/login")
    }
  }

  // Fetch counts from backend
  const fetchCounts = async () => {
    try {
      const response = await fetch(`${apiURl}/api/dashboard/counts`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
      const result = await response.json()
      if (response.ok && result.status === "success") {
        setCounts(result.counts)
      } else {
        toastr.error(result.message || "Failed to fetch counts")
      }
    } catch (error) {
      console.error("Fetch Counts Error:", error)
      toastr.error("Failed to fetch counts")
    }
  }
  const fetchReports = async () => {
    try {
      const response = await fetch(
        `${apiURl}/api/dashboard/countsReports?clientID=${clientID}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      )
      const result = await response.json()
      if (response.ok && result.status === "success") {
        setCountReports(result.counts)
      } else {
        toastr.error(result.message || "Failed to fetch counts")
      }
    } catch (error) {
      console.error("Fetch Counts Error:", error)
      toastr.error("Failed to fetch counts")
    }
  }

  useEffect(() => {
    checkSession()
    fetchReports()
    fetchCounts()
  }, [])

  //meta title
  document.title = "Dashboard"
  const Role = localStorage.getItem("role")
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          <Row>
            <Col xl="12">
              <Row>
                {(Role === "Admin" || Role === "Sub-Admin") && (
                  <>
                    <Col md="3">
                      <Link to="/users">
                        <Card className="mini-stats-wid">
                          <CardBody>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="text-muted fw-medium">Users</p>
                                <h4 className="mb-0">{Counts.users}</h4>
                              </div>
                              <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                                <span className="avatar-title rounded-circle bg-success">
                                  <i className={"bx bx-user font-size-24"}></i>
                                </span>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col md="3">
                      <Link to="/clients">
                        <Card className="mini-stats-wid">
                          <CardBody>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="text-muted fw-medium">Clients</p>
                                <h4 className="mb-0">{Counts.clients}</h4>
                              </div>
                              <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                                <span className="avatar-title rounded-circle bg-success">
                                  <i
                                    className={"bx bx-user-plus font-size-24"}
                                  ></i>
                                </span>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Link>
                    </Col>
                  </>
                )}
                {Role === "Client" && (
                  <Col md="3">
                    <Link to="/monthly-report">
                      <Card className="mini-stats-wid">
                        <CardBody>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <p className="text-muted fw-medium">
                                Total Reports
                              </p>
                              <h4 className="mb-0">{countsReports}</h4>
                            </div>
                            <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-success">
                                <i className={"bx bxs-report font-size-24"}></i>
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
